import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import ModalHeader from '@common-components/headers/ModalHeader';

const FailureModal = props => {

    const {
        modalHeaderProps,
        actions: {
            hideModal
        },
        modal: { modalData = {} },
    } = props;

    const handleCloseModal = () => hideModal();

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader {...{ ...modalHeaderProps, modalHeaderTextData: modalData?.failureHeaderText || modalHeaderProps.modalHeaderTextData }} />
            </div>
            <div className="grid-container">
                <div className="gi-modal__body">
                    <FormattedMessage id={modalData?.failureMessage || 'common.technical_issues_body'} tagName='p' />
                </div>
            </div>
            <div className="gi-modal__controls">
                <button onClick={handleCloseModal}
                    className="usa-button gi-button gi-button__primary">
                    <FormattedMessage id="dashboard.ok"/>
                </button>
            </div>
        </Fragment>
    );
};

export default FailureModal;
